
import { Button, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import { getAllOrderedService, getAllServicesService, getContractorServices } from "../../services/servicesServices.js";
import EmailAndPhone from "../Users/additionFields/EmailAndPhone.jsx";
import Actions from "./additionFields/Actions.jsx";
import ServiceImage from "./additionFields/ServiceImage.jsx";
import ConstructionStatus from "./additionFields/ConstructionStatus.jsx";
import Contractor from "./additionFields/Contractor.jsx";
import Payment from "./additionFields/Payment.jsx";
import Score from "./additionFields/Score.jsx";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import { base_api_url } from "../../services/httpService.js";
import { DownloadRounded, QuestionAnswer } from "@mui/icons-material";
import { fileDownloaderWithName, fileDownloaderWithoutFormat } from "../../utils/fileDownloader.js";
import ReceiveService from "./additionFields/ReceiveService.jsx";
import ModalContainer from "../../components/ModalContainer.jsx";
import ManagerDetail from "./additionFields/ManagerDetail.jsx";

const ContractorServicePage = () => {
  const [forceRequest, setForceRequest] = useState(0);

  const location = useLocation()
  const contractor = location.state?.contractor; 


  const servicesCols = [
    {
      field: "code",
      text: "کد سرویس",
    },
    {
      field: null,
      text: "تصویر",
      element: (rowData) => (
        <ServiceImage rowData={rowData} scrollQuery="#div-content" />
      ),
    },
    {
      field: null,
      text: "وضعیت سفارش",
      element: (rowData) => <ConstructionStatus rowData={rowData} />,
    },
    {
      field: null,
      text: "پیمانکار",
      element: (rowData) => <Contractor rowData={rowData} />,
    },
    {
      field: null,
      text: "مبلغ (تومان)",
      element: (rowData) => <Payment rowData={rowData} />,
    },
    {
      field: null,
      text: "تاریخ تحویل",
      element: (rowData) => <span>{convertDateToJalaali(rowData.preparation_date)}</span>,
    },
    {
      field: null,
      text: "جزییات",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            onClick={() =>
              window.open(
                `http://app.wisercam.com/DetailOrder/${rowData.code}`
              )
            }
          >
            مشاهده
          </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithName(`${base_api_url}/shop_admin/get_customer_file/${rowData.code}/`, null, false);
                        // fileDownloaderWithName(`${base_api_url}/shop_admin/get_map_file/${rowData.code}/`, "uploaded_mfile.stp", false)
                        fileDownloaderWithoutFormat(`${base_api_url}/shop_admin/get_local_customer_file/${rowData.code}/`)
                    }}
            >
                دانلود
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "توضیحات",
      element: (rowData) =>  <ManagerDetail rowData={rowData} iO={"c"} />
    },
    {
      field: null,
      text: "امتیاز",
      element: (rowData) => <Score rowData={rowData} />,
    },
  ];

  return (
    <DataTablePagination
      tableCols={servicesCols}
      title={contractor ? `قطعات ${contractor.full_name}` : "قطعات من"}
      APIFunction={getContractorServices}
      dataField={"services"}
      forceRequest={forceRequest}
      hasContractorId={true}
      contractorId={contractor ? contractor.id : ""}
      setForceRequest={setForceRequest}
    ></DataTablePagination>
  );
};

export default ContractorServicePage;
